import { MessageBox } from "element-ui"
export default function open7moor(e) {
  e.stopPropagation()
  e.preventDefault()
  if (!canUseKf()) {
    MessageBox({
      message: "请使用IE10及以上版本浏览器在线咨询",
      title: "提示",
      center: true,
      confirmButtonText: "知道了"
    })
    return
  }
  window.qimoChatClick && window.qimoChatClick()
}
function canUseKf() {
  const version = IEVersion()
  return !(isIE() && (version < 10 && version !== "edge"));
}
function isIE() {
  return !!window.ActiveXObject || "ActiveXObject" in window
}
function IEVersion() {
  const userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  const isIE = userAgent.includes("compatible") && userAgent.includes("MSIE") // 判断是否IE<11浏览器
  const isEdge = userAgent.includes("Edge") && !isIE // 判断是否IE的Edge浏览器
  const isIE11 = userAgent.includes("Trident") && userAgent.includes("rv:11.0")
  if (isIE) {
    const reIE = /MSIE (\d+\.\d+);/
    reIE.test(userAgent)
    const fIEVersion = parseFloat(RegExp.$1)
    return fIEVersion >= 7 ? fIEVersion : 6
  } else if (isEdge) {
    return "edge"// edge
  } else if (isIE11) {
    return 11 // IE11
  } else {
    return -1// 不是ie浏览器
  }
}
